import React, { useState } from 'react';
import { Layout } from '../../../../../queries/ats/layout/types';
import { SectionGrid } from '../SectionGrid';

const TAKE = 40;

interface PersonalizedGridProps {
  view: Layout.SectionView;
  data: Layout.SectionItem[];
}

export function PersonalizedGrid({ view, data }: PersonalizedGridProps) {
  const [page, setPage] = useState(1);
  const items = data.slice(0, page * TAKE);
  return <SectionGrid view={view} data={items} onScrollBottom={() => setPage((p) => p + 1)} />;
}
